import { Box } from '@utilitywarehouse/hearth-react';
import type { CSSProperties, ReactNode } from 'react';

interface InnerContainerProps {
  children: ReactNode;
  maxWidth?: number;
  style?: CSSProperties;
}

/**
 * InnerContainer - Centers content and constrains width
 *
 * Default max-width: 1096px (matches --layout-container-width)
 * Provides horizontal padding on smaller screens
 */
function InnerContainer({
  children,
  maxWidth = 1096,
  style,
}: InnerContainerProps) {
  return (
    <Box
      style={{
        maxWidth: `${maxWidth}px`,
        width: '100%',
        margin: '0 auto',
        ...style,
      }}
      paddingX={{
        mobile: '200',
        tablet: '400',
        desktop: '0',
      }}
    >
      {children}
    </Box>
  );
}

export default InnerContainer;
